var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useId } from 'react';
import { useTheme } from '@mui/material';
var GRAIN_SVG = "data:image/svg+xml;utf8,".concat(encodeURIComponent("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"240\" height=\"240\">\n     <filter id=\"n\">\n       <feTurbulence type=\"fractalNoise\" baseFrequency=\"0.9\" numOctaves=\"2\" stitchTiles=\"stitch\"/>\n       <feColorMatrix values=\"0 0 0 0 0  0 0 0 0 0  0 0 0 0 0  0 0 0 0.55 0\"/>\n     </filter>\n     <rect width=\"100%\" height=\"100%\" filter=\"url(#n)\"/>\n   </svg>"));
export var MeshGradient = function (_a) {
    var config = _a.config;
    var backrs = useTheme().backrs;
    var baseColor = config.baseColor, blobs = config.blobs, _b = config.blurPx, blurPx = _b === void 0 ? 30 : _b, _c = config.grainOpacity, grainOpacity = _c === void 0 ? 0.35 : _c;
    var filterId = "mesh-blur-".concat(useId().replace(/[^a-zA-Z0-9_-]/g, ''));
    return (_jsxs("div", { style: containerStyle(backrs.colors[baseColor]), children: [_jsxs("svg", { width: "100%", height: "100%", style: meshSvgStyle, "aria-hidden": "true", children: [_jsx("defs", { children: _jsx("filter", { id: filterId, x: "-50%", y: "-50%", width: "200%", height: "200%", children: _jsx("feGaussianBlur", { stdDeviation: blurPx }) }) }), _jsx("g", { filter: "url(#".concat(filterId, ")"), children: blobs.map(function (blob, i) { return (_jsx("svg", __assign({}, blobPlacement(blob), { viewBox: "0 0 100 100", preserveAspectRatio: "none", overflow: "visible", style: blobRotationStyle(blob.rotate), children: _jsx("path", { d: blob.shape, fill: backrs.colors[blob.color] }) }), i)); }) })] }), _jsx("div", { style: grainStyle(grainOpacity) })] }));
};
var blobPlacement = function (blob) {
    var scale = function (value) { return parseFloat(value !== null && value !== void 0 ? value : '0%') * 1.5; };
    var width = scale(blob.width);
    var height = scale(blob.height);
    var x = blob.left !== undefined ? -25 + scale(blob.left) : 125 - scale(blob.right) - width;
    var y = blob.top !== undefined ? -25 + scale(blob.top) : 125 - scale(blob.bottom) - height;
    return { x: "".concat(x, "%"), y: "".concat(y, "%"), width: "".concat(width, "%"), height: "".concat(height, "%") };
};
var blobRotationStyle = function (rotate) { return ({
    transform: "rotate(".concat(rotate, "deg)"),
    transformOrigin: 'center',
    transformBox: 'fill-box',
}); };
var containerStyle = function (baseColor) { return ({
    position: 'absolute',
    inset: 0,
    overflow: 'hidden',
    backgroundColor: baseColor,
    pointerEvents: 'none',
}); };
var meshSvgStyle = {
    position: 'absolute',
    inset: 0,
};
var grainStyle = function (opacity) { return ({
    position: 'absolute',
    inset: 0,
    backgroundImage: "url(\"".concat(GRAIN_SVG, "\")"),
    backgroundSize: '240px 240px',
    mixBlendMode: 'overlay',
    opacity: opacity,
}); };
